import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();
  const [reload, setreload]=useState(false)
  // const [user]=useAuthState(auth);
  const [token, setToken] = useState(localStorage.accessToken);
  function refreshPage(){ 
    window.location.reload(); 
  }
 
  useEffect(() => {
    const ltoken=localStorage.getItem("accessToken")
    setToken(ltoken)
    
   

    
    // if(reload){
    //   const myTimeout= setTimeout(refreshPage, 10000);
    //   setreload(false)
    // }
    //     // setreload(!reload)
    //     // refreshPage()
    // }
    // if (!reload) {
    //   window.location.reload()
    //   setreload(!reload)
     
    // }
  }, [token]);

  const handleSignOut = () =>{
    localStorage.removeItem("accessToken")
    setToken('')
    navigate('/')
    
    
    
}
  return (
    <div className='header mb-4' >
    <div className='container '>
      <nav class="navbar  fixed-top navbar-expand-lg navbar-light bg-light ">
<div class="container-fluid">

<Link class="navbar-brand text-primary fs-5" to="/">Sazid Photography Event</Link>
<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
<span class="navbar-toggler-icon"></span>
</button>
<div class="collapse navbar-collapse" id="navbarSupportedContent">
<ul class="navbar-nav ms-auto mb-2 mb-lg-0">
  <li class="nav-item">
  
  <Link class="nav-link " to="/">Home</Link>
   
  </li>
  <li class="nav-item">

  <NavLink href="home#services">Services</NavLink>
  

  </li>
  <li class="nav-item">
 
    <Link class="nav-link" to="/about" >About</Link>
  </li>
  <li class="nav-item">
    
    <Link class="nav-link" to="/blog" >Blog</Link>
  </li>
  <li class="nav-item">
    {
     token? 
      <button className='btn btn-danger text-decoration-none' onClick={handleSignOut} >sign out</button>
    :
    <Link class="nav-link" to="/login" >Login</Link>
}
  </li>

 

</ul>

</div>
</div>
</nav>
</div>
</div>
  );
};

export default Header;